import { all, put, call, takeEvery, select } from 'redux-saga/effects'
import Storage from '@aws-amplify/storage' // YQ: need to create storage service
import moment from 'moment'
import clinicPatientActions from './actions'
import {
  getClinicPatients,
  addClinicPatient,
  getAvailableDevices,
  unassignDeviceFromPatient,
  updatePatient,
  reAdmitPatient,
  deletePatient,
  deleteMultiplePatient,
  getPatientIdsForDevice,
  dischargePatient,
  getClinicPatientDetail,
  storeResidentChangeNote,
  getStatusesLogs,
  clinicPatientSetState,
  deviceSetState,
  getClinicDailyReportClinic,
  getDeviceLastTwoHourData,
  profileSetState,
} from '../actions'
import { groupPatientsByFlag, notification, analytics } from '../../services/index'
import { GET_CLINIC_DEVICES } from '../device/sagas'
import { GET_CLINIC_PATIENTS_DB, getLastRRForAllPatients } from '../dashboard/sagas'
import {
  SOCKET_HANDLER,
  GET_RESIDENT_STATUS_NOTES,
  GET_DAILY_PATIENT_REPORT,
} from '../profile/sagas'
import { getAllStoredNotesOfPatient } from '../profile/actions'

const getUser = (state) => state.user
const getClinic = (state) => state.clinic
const getDevice = (state) => state.device
const getProfile = (state) => state.profile

// Function to get A List of Invoices from Server and Save it in Redux Store
export function* GET_CLINIC_PATIENTS({ payload }) {
  let { data } = payload
  yield put(
    clinicPatientSetState({
      clinicPatientLoading: true,
      clinicPatientsList: [],
      clinicDischargePatientsList: [],
      clinicDeletedPatientsList: [],
    }),
  )
  const { role } = yield select(getUser)
  const { userClinic } = yield select(getClinic)
  // how status is working please check this document: https://shorturl.at/grKQV
  data = {
    clinic_id: userClinic.id,
    // status: 1,
    ...data,
  }
  // const clinicPatientsList = yield call(getClinicPatients, role, data)
  const requestPayload = {
    date: moment().format('YYYY-MM-DD'),
    clinic_id: userClinic.id,
  }
  const [clinicPatientsList, clinicDischargePatientsList, clinicDeletedPatientsList, response] =
    yield all([
      call(getClinicPatients, role, { ...data, status: 1 }),
      call(getClinicPatients, role, { ...data, status: 2 }),
      call(getClinicPatients, role, { ...data, status: 0 }),
      call(getClinicDailyReportClinic, requestPayload),
    ])

  if (!response) {
    notification.error('Unable to fetch report data')
  }
  if (clinicPatientsList && clinicPatientsList.length > 0 && response && response.length > 0) {
    clinicPatientsList.map((item) => {
      item.reportData = { rr_avg: null, time_in_bed: null }
      const reportObject = response.filter((datum) => datum.patient_id === item.patient_id)
      if (reportObject.length > 0) {
        const [reportData] = reportObject
        item.reportData = reportData
      }
      return item
    })
  }
  const patientsGroupedByFlags = groupPatientsByFlag(clinicPatientsList)
  delete patientsGroupedByFlags[1]
  yield put(
    clinicPatientSetState({
      clinicPatientLoading: false,
      clinicPatientsList,
      clinicDischargePatientsList,
      clinicDeletedPatientsList,
      patientsGroupedByFlags,
    }),
  )

  // Calling Analytic Event log
  analytics.event({
    action: 'get_clinic_patients',
    category: 'resident_dir',
    label: 'onPageLoad',
    value: data,
  })
}

export function* ADD_CLINIC_PATIENT({ payload }) {
  yield put(clinicPatientSetState({ clinicPatientAddLoading: true }))
  const { role } = yield select(getUser)
  const { userClinic } = yield select(getClinic)

  // eslint-disable-next-line prefer-const
  let { data } = payload

  const dataTobeSent = {
    ...data,
    clinic_id: userClinic.id,
  }

  const { information_file: faceSheet } = data

  if (data.isDocumentChanged) {
    const fileNameStatic = faceSheet.name
    window.log('data add', data, faceSheet, fileNameStatic)
    const fileName = yield call(
      uploadFile,
      'clinicPatient',
      faceSheet.originFileObj,
      `${fileNameStatic.split('.')[0]}-${dataTobeSent.billing_information}-${
        dataTobeSent.information_file.lastModified
      }`,
    )
    dataTobeSent.information_file = fileName
  }

  const response = yield call(addClinicPatient, dataTobeSent, role)

  if (!response.success) {
    window.log('response', response)
    return yield put(clinicPatientSetState({ clinicPatientAddLoading: false }))
  }
  yield call(GET_CLINIC_PATIENTS, { payload: {} })
  yield call(GET_CLINIC_PATIENTS_DB, { payload: {} })
  return yield put(clinicPatientSetState({ clinicPatientAddLoading: false, redirect: true }))
}

export function* UPDATE_PATIENT({ payload }) {
  yield put(clinicPatientSetState({ clinicPatientAddLoading: true }))
  const { role } = yield select(getUser)
  const { userClinic } = yield select(getClinic)
  let { data } = payload
  data = {
    ...data,
    clinic_id: userClinic.id,
  }
  const { information_file: faceSheet } = data

  if (data.isDocumentChanged) {
    const fileNameStatic = faceSheet.name
    window.log('data add', data, faceSheet, fileNameStatic)
    const fileName = yield call(
      uploadFile,
      'clinicPatient',
      faceSheet.originFileObj,
      `${fileNameStatic.split('.')[0]}-${data.billing_information}-${
        data.information_file.lastModified
      }`,
    )
    data.information_file = fileName
  }
  const response = yield call(updatePatient, role, data)
  if (!response.success) {
    return yield put(clinicPatientSetState({ clinicPatientAddLoading: false }))
  }
  yield call(GET_CLINIC_PATIENTS, { payload: {} })
  yield call(GET_CLINIC_PATIENTS_DB, { payload: {} })

  return yield put(clinicPatientSetState({ clinicPatientAddLoading: false, redirect: true }))
}

export function* GET_PATIENT_DETAIL({ payload }) {
  yield put(profileSetState({ patientProfileLoading: true }))

  const { role } = yield select(getUser)

  const { data } = payload
  const { patientId } = data
  const { userClinic } = yield select(getClinic)

  const [patientDetail] = yield call(getClinicPatientDetail, role, {
    patient_id: patientId,
    clinic_id: userClinic.id,
  })
  window.log('patientDetail', patientDetail)
  const patientFileUrl = yield call(
    getDocumentFromS3,
    'clinicPatient',
    patientDetail.information_file,
  )
  patientDetail.documentLink = patientFileUrl
  const { inventoryDevices } = yield select(getDevice)

  if (inventoryDevices.length > 0) {
    inventoryDevices.map(({ device_id: deviceId, device_name: name }) => {
      if (deviceId === patientDetail.device_id) {
        patientDetail.deviceName = name
      }
      return false
    })
  }

  yield put(profileSetState({ patientProfileLoading: false, patientDetail }))
}

export function* GET_PATIENT_PROFILE({ payload }) {
  yield put(profileSetState({ nightByNightLoading: true, graphLoading: true }))

  const { data } = payload
  const { patientId } = data
  const { userClinic } = yield select(getClinic)
  let { profileTimezone, memberDetail: patientDetail } = yield select(getProfile)
  const { role } = yield select(getUser)

  const { inventoryListingDevices } = yield select(getDevice)
  if (!patientDetail.patient_id || data.reloadData) {
    const [patientData, patientLastRR] = yield all([
      call(getClinicPatientDetail, role, {
        patient_id: patientId,
        clinic_id: userClinic.id,
      }),
      call(getLastRRForAllPatients, { clinic_id: userClinic.id, patient_id: patientId }),
    ])
    patientDetail = patientData.length > 0 ? patientData[0] : {}
    patientDetail.dist_rr = patientLastRR.length > 0 ? patientLastRR[0].dist_rr : null
  }

  yield call(GET_DAILY_PATIENT_REPORT, {
    payload: { clinic_id: userClinic.id, patient_id: patientId },
  })

  const payloadForLastTwoHour = {
    clinic_id: userClinic.id,
    hours: 2,
    patient_id: patientId,
  }
  let lastTwoHourData = {}
  if (Object.keys(patientDetail).length > 0 && patientDetail.device.device_id) {
    lastTwoHourData = yield call(getDeviceLastTwoHourData, payloadForLastTwoHour)
  }

  const currentDevice = {}
  if (inventoryListingDevices.data) {
    Object.assign(
      currentDevice,
      ...inventoryListingDevices.data.filter(
        (item) => item.device_id === patientDetail.device.device_id,
      ),
    )
  }

  if (Object.keys(currentDevice).length === 0) {
    Object.assign(currentDevice, patientDetail.device)
    currentDevice.name = patientDetail.device.device_name
  }
  let timezone
  if (currentDevice.tz) {
    const { tz } = currentDevice
    timezone = tz
  } else {
    const { device_tz: tz } = currentDevice
    timezone = tz
  }

  profileTimezone = timezone

  // if (false) {
  yield call(SOCKET_HANDLER, {
    payload: { deviceId: patientDetail.device.device_id, type: 'connect', patientDetail },
  })
  // }

  // const dataobj = {
  //   member_id: patientId,
  //   userUID: patientId,
  //   clinic_id: userClinic.id,
  // }

  // const getHistoryNotes = yield call(historyNotes, dataobj)
  const getResidentStatus = yield call(getAllStoredNotesOfPatient, { patient_id: patientId })

  yield put(
    profileSetState({
      memberDetail: patientDetail,
      currentDevice,
      profileTimezone,
      // getHistoryNotes,
      nightByNightLoading: false,
      lastTwoHourData,
      graphLoading: false,
      getResidentStatus,
    }),
  )

  analytics.event({
    action: clinicPatientActions.GET_PATIENT_PROFILE,
    category: 'profile',
    label: 'onPageLoad',
    value: { patient_id: patientId, clinic_id: userClinic.id, type: 'Live' },
  })
}

export function* GET_AVAILABLE_DEVICES() {
  yield put(clinicPatientSetState({ availableDevicesLoading: true }))

  const { userClinic } = yield select(getClinic)
  const data = {
    clinic_id: userClinic.id,
  }

  const { role } = yield select(getUser)
  const availableDevices = yield call(getAvailableDevices, role, data)

  yield put(clinicPatientSetState({ availableDevices, availableDevicesLoading: false }))

  analytics.event({
    action: 'get_available_devices',
    category: 'resident_dir',
    label: 'onPageLoad',
    value: data,
  })
}

export function* UNASSIGN_DEVICE({ payload }) {
  yield put(deviceSetState({ inventoryLoading: true }))
  const { data } = payload
  const { role } = yield select(getUser)

  const response = yield call(unassignDeviceFromPatient, role, data)

  if (!response.success) {
    return yield put(deviceSetState({ inventoryLoading: false }))
  }
  yield call(GET_CLINIC_PATIENTS, { payload: {} })
  yield call(GET_CLINIC_DEVICES, { payload })
  yield call(GET_CLINIC_PATIENTS_DB, { payload: {} })
  yield put(deviceSetState({ inventoryLoading: false, modalVisible: false }))
  const { isButton = false } = payload
  if (isButton) {
    return true
  }
  return yield put(clinicPatientSetState({ redirect: true }))
}

export function* DELETE_MULTIPLE_PATIENTS({ payload }) {
  const { role } = yield select(getUser)
  yield put(clinicPatientSetState({ clinicPatientLoading: true }))
  const res = yield call(deleteMultiplePatient, role, payload)
  if (res.success) {
    yield call(GET_CLINIC_DEVICES, { payload: {} }) // room diractory
    if (payload.status === 0) {
      yield call(GET_AVAILABLE_DEVICES) // available devices
    }
    yield call(GET_CLINIC_PATIENTS_DB, { payload: {} })
  }
  yield put(clinicPatientSetState({ clinicPatientLoading: false }))
}

export function* DELETE_PATIENT({ payload }) {
  yield put(profileSetState({ patientProfileLoading: true }))
  const { data } = payload

  const { userClinic } = yield select(getClinic)
  data.clinic_id = userClinic.id
  const { role } = yield select(getUser)

  let response = yield call(deletePatient, role, data)

  if (!response.success) {
    return yield put(profileSetState({ patientProfileLoading: false }))
  }
  response = yield call(unassignDeviceFromPatient, role, data)

  if (!response.success) {
    return yield put(profileSetState({ patientProfileLoading: false }))
  }

  yield call(GET_CLINIC_PATIENTS, { payload: {} })
  yield call(GET_CLINIC_PATIENTS_DB, { payload: {} })
  return yield put(clinicPatientSetState({ clinicPatientAddLoading: false, redirect: true }))
}

export function* DISCHARGE_PATIENT({ payload }) {
  const { data } = payload
  const { role } = yield select(getUser)
  const { userClinic } = yield select(getClinic)

  yield put(clinicPatientSetState({ clinicPatientLoading: true }))

  const response = yield call(
    dischargePatient,
    role,
    { ...data, clinic_id: userClinic.id, status: 2 },
    false,
  )
  if (response.success) {
    notification.success(`Success`, 'Resident Discharged Successfully')
    yield call(GET_CLINIC_PATIENTS, { payload: {} })
    yield call(GET_AVAILABLE_DEVICES) // available devices
    yield call(GET_CLINIC_DEVICES, { payload: {} }) // room diractory
    yield call(GET_CLINIC_PATIENTS_DB, { payload: {} })
  }

  yield put(clinicPatientSetState({ clinicPatientLoading: false }))
}

export function* READMIT_PATIENT({ payload }) {
  const { data } = payload
  const { role } = yield select(getUser)
  data.status = 1
  window.log('READMIT_PATIENT', data)
  yield put(clinicPatientSetState({ clinicPatientsLoading: true }))
  const response = yield call(reAdmitPatient, role, data, false)
  if (response.success) {
    notification.success(`Success`, 'Resident readmitted successfully')
    yield call(GET_CLINIC_PATIENTS, { payload: {} })
  }

  yield put(clinicPatientSetState({ clinicPatientsLoading: false }))
}

export function* GET_PATIENT_IDS({ payload }) {
  yield put(clinicPatientSetState({ patientIdsLoading: true, patientIds: [] }))
  const { role } = yield select(getUser)

  const { response: patientIds, success } = yield call(getPatientIdsForDevice, role, payload)
  let payloadToBeSent = {
    patientIdsLoading: false,
    patientIds,
  }
  if (!success) {
    payloadToBeSent = {
      patientIdsLoading: false,
      patientIds: [],
    }
  }
  yield put(clinicPatientSetState, payloadToBeSent)
}

let getReloadLogs = 0
export function* STORE_CHANGE_NOTES({ payload }) {
  const { role } = yield select(getUser)
  yield put(clinicPatientSetState({ changeStoreNoteLoading: true, clinicPatientLoading: true }))

  if (payload.fileList && payload.fileList.length > 0) {
    const [fileList] = payload.fileList
    const fileNameStatic = fileList.name
    const fileName = yield call(
      uploadFile,
      'clinicPatient',
      fileList.originFileObj,
      `${fileNameStatic.split('.')[0]}-${payload.patient_id}-${fileList.lastModified}`,
    )
    payload.uploadedFile = fileName
  }
  if (payload.pdfBlob) {
    const fileNameStatic = payload.pdfBlob.name
    const fileName = yield call(
      uploadFile,
      'clinicPatient',
      payload.pdfBlob,
      `${fileNameStatic.split('.')[0]}-${payload.patient_id}`,
    )
    payload.uploadedFile = fileName
  }

  if (payload.status === 4) {
    const { origin } = window
    payload.urlToSend = `${origin}/#/patient?ResidentType=4&selectedResident=${payload.patient_id}`
  }

  const response = yield call(storeResidentChangeNote, role, payload)
  if (response === 'success') {
    notification.success(`Success`, 'Change Note stored successfully')
    if (payload.reloadData) {
      yield call(GET_PATIENT_PROFILE, { payload: { data: { patientId: payload.patient_id } } })
      payload.member_id = payload.patient_id
      payload.userUID = payload.patient_id
      yield call(GET_RESIDENT_STATUS_NOTES, { payload })
    }
    yield call(GET_CLINIC_PATIENTS, { payload: {} })
    yield call(GET_CLINIC_PATIENTS_DB, { payload: {} })
  }
  getReloadLogs += 1
  yield put(
    clinicPatientSetState({
      changeStoreNoteLoading: false,
      clinicPatientLoading: false,
      getReloadLogs,
    }),
  )
}

export function* GET_CHANGE_STATUSES_LOGS() {
  yield put(profileSetState({ logsLoading: true }))
  const { role } = yield select(getUser)
  const { userClinic } = yield select(getClinic)
  const statusesLogs = yield call(getStatusesLogs, role, { clinic_id: userClinic.id })
  yield put(profileSetState({ logsLoading: false, statusesLogs }))
}

export const uploadFile = async (path, file, fileName, isExtension = true) => {
  const ext = getFileExtension(file.name)
  let fileNameToBeSent = `${fileName}`
  if (isExtension) {
    fileNameToBeSent = `${path}/${fileName}.${ext}`
  }
  Storage.configure({
    AWSS3: {
      bucket: 'resident-face-sheet',
      region: 'us-east-1',
    },
  })
  await Storage.put(fileNameToBeSent, file)
    .then((callback) => callback)
    .catch((e) => window.log('error uploading file', e))

  return `${fileName}.${ext}`
}

export const getFileExtension = (filename) => {
  const re = /(?:\.([^.]+))?$/
  const ext = re.exec(filename)[1]

  return ext
}

export const getDocumentFromS3 = async (path, fileName) => {
  Storage.configure({
    AWSS3: {
      bucket: 'resident-face-sheet',
      region: 'us-east-1',
    },
  })
  const document = await Storage.get(`${path}/${fileName}`, {})
    .then((result) => result)
    .catch((err) => window.log('DocumentFromS3 error ', err))
  return document
}

// Assigning constant Strings to Saga Functions, in order to access Saga Functions from Redux
export default function* rootSaga() {
  yield all([
    takeEvery(clinicPatientActions.DISCHARGE_PATIENT, DISCHARGE_PATIENT),
    takeEvery(clinicPatientActions.STORE_CHANGE_NOTES, STORE_CHANGE_NOTES),
    takeEvery(clinicPatientActions.GET_CLINIC_PATIENTS, GET_CLINIC_PATIENTS),
    takeEvery(clinicPatientActions.ADD_CLINIC_PATIENT, ADD_CLINIC_PATIENT),
    takeEvery(clinicPatientActions.GET_PATIENT_IDS, GET_PATIENT_IDS),
    takeEvery(clinicPatientActions.READMIT_PATIENT, READMIT_PATIENT),
    takeEvery(clinicPatientActions.GET_PATIENT_PROFILE, GET_PATIENT_PROFILE),
    takeEvery(clinicPatientActions.GET_AVAILABLE_DEVICES, GET_AVAILABLE_DEVICES),
    takeEvery(clinicPatientActions.UNASSIGN_DEVICE, UNASSIGN_DEVICE),
    takeEvery(clinicPatientActions.GET_PATIENT_DETAIL, GET_PATIENT_DETAIL),
    takeEvery(clinicPatientActions.UPDATE_PATIENT, UPDATE_PATIENT),
    takeEvery(clinicPatientActions.DELETE_PATIENT, DELETE_PATIENT),
    takeEvery(clinicPatientActions.GET_CHANGE_STATUSES_LOGS, GET_CHANGE_STATUSES_LOGS),
    takeEvery(clinicPatientActions.DELETE_MULTIPLE_PATIENT, DELETE_MULTIPLE_PATIENTS),
  ])
}
